import moment from "moment";
import { api } from "common";
import { useState } from "react";
import { Column } from "material-table";
import { useTranslation } from "react-i18next";
import { Map as MapIcon } from "@mui/icons-material";
import { ISavedAddressType } from "common/src/types";
import { useSelector, useDispatch } from "react-redux";
import { MapLocationPicker } from "components/MapLocationPicker";
import { CustomMaterialTable } from "components/CustomMaterialTable";
import { ThemedModalContainer } from "components/modal/ModalContainer";

export default function AdmSavedAddresses() {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const { editAdmSavedAddresses } = api;
  const settings = useSelector((state) => state.settingsdata.settings);
  const admSavedAddresses = useSelector((state) => state.admSavedAddresses);
  const [isMapModalOpen, setIsMapModalOpen] = useState<ISavedAddressType | undefined>(undefined);

  const handleLocationSelect = (lat: number, lng: number) => {

    const updatedData: any = {
      ...isMapModalOpen,
      lat: lat,
      lng: lng,
    };

    dispatch(editAdmSavedAddresses(updatedData, "Update"));

  };

  const columns: Column<ISavedAddressType>[] = [
    {
      field: "createdAt",
      editable: "never",
      defaultSort: "desc",
      title: t("createdAt"),
      render: (rowData) => moment(rowData.createdAt).format("lll"),
    },
    {
      field: "active",
      type: "boolean",
      title: t("active_status"),
    },
    {
      field: "name",
      type: "string",
      title: t("title"),
      validate: rowData => rowData.name ? true : t("required")
    },
    {
      type: "string",
      field: "description",
      title: t("description"),
    },
    {
      field: "lat",
      type: "string",
      title: "Latitude",
    },
    {
      field: "lng",
      type: "string",
      title: "Longitude",
    }
  ];

  return (
    <>
      <CustomMaterialTable
        columns={columns}
        title={"saved_address"}
        data={admSavedAddresses.date ?? []}
        isLoading={admSavedAddresses.loading}
        editable={{
          onRowAdd: (newData) =>
            settings?.AllowCriticalEditsAdmin
              ? new Promise((resolve) => {
                setTimeout(() => {
                  dispatch(editAdmSavedAddresses(newData, "Add"));
                  resolve("");
                }, 100);
              })
              : new Promise((resolve) => {
                setTimeout(() => {
                  resolve("");
                  alert(t("demo_mode"));
                }, 600);
              }),
          onRowUpdate: (newData) =>
            settings?.AllowCriticalEditsAdmin
              ? new Promise((resolve) => {
                setTimeout(() => {
                  dispatch(editAdmSavedAddresses(newData, "Update"));
                  resolve("");
                }, 100);
              })
              : new Promise((resolve) => {
                setTimeout(() => {
                  resolve("");
                  alert(t("demo_mode"));
                }, 600);
              }),
          onRowDelete: (oldData) =>
            settings?.AllowCriticalEditsAdmin
              ? new Promise((resolve) => {
                setTimeout(() => {
                  dispatch(editAdmSavedAddresses(oldData, "Delete"));
                  resolve("");
                }, 600);
              })
              : new Promise((resolve) => {
                setTimeout(() => {
                  resolve("");
                  alert(t("demo_mode"));
                }, 600);
              }),
        }}
        actions={[
          (rowData: ISavedAddressType) => ({
            icon: MapIcon,
            tooltip: t("select_location"),
            onClick: () => setIsMapModalOpen(rowData),
          }),
        ]}
      />

      <ThemedModalContainer
        maxWidth={900}
        title={t("edit_location")}
        open={isMapModalOpen !== undefined}
        onClose={() => { setIsMapModalOpen(undefined) }}
      >

        <MapLocationPicker
          initialLat={isMapModalOpen?.lat}
          initialLng={isMapModalOpen?.lng}
          onLocationSelect={handleLocationSelect}
          onClose={() => { setIsMapModalOpen(undefined) }}
        />

      </ThemedModalContainer>
    </>
  );
}